export const MerchantEnum = Object.freeze({
  STOOM_MERCHANT: 'Merchant Stoom',
  LUMINI_MERCHANT: 'Merchant Lumini',
  SPORTBAY_MERCHANT: 'Merchant Default',
  INSUMOS_HOLAMBRA_MERCHANT: 'Merchant Insumos Holambra',
});
